var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showTooltip)?[_c('t-tooltip',{attrs:{"content":_vm.tooltip,"placement":"top-left"}},[_vm._t("components")],2)]:[_vm._t("components")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }